//TODO:  Should we change the type to snake case to match what we bring back from the SDK tran?

export enum UserDefinedParentType {
  Entity = 'Entity',
  Contract = 'Contract',
  Claim = 'Claim'
}

export interface DynamicFieldConfig {
  // USE DATABASE TABLE NAMING NOMENCLATURE AFTER SDK DEFINED???  OR TRANSLATE FROM SDK RETURN TO THIS STRUCTURE ON LOAD?
  key: string;
  controlPath: string;
  descControlPath?: string;
  type: 'Character' | 'DateTime' | 'Integer' | 'Number' | 'Text'; //TODO: Are these the right values?   Should we sync with Report Criteria call?
  length: number;
  decimal?: number;
  label: string;
  hidden: boolean;
  columnSpan: string;
  order: number;
  format: string;
  initialValue?: string;
  protected: boolean;
  options?: {
    codeValues?: [
      {
        Code: string;
        Code_Desc: string;
      }
    ];
    rows?: number;
    userDefinedMode?: boolean;
  };
  criteria?: {};
}

export interface UserDefinedTableConfig {
  objectCode: string;
  parentObjectCode: UserDefinedParentType;
  title: string;
  dbTableName: string;
  dbIDColumn: string;
  dbGUIDColumn: string;
  dbTitleColumn: string;
  singleRecord: boolean;
  fieldConfig: DynamicFieldConfig[];
}

export interface UserDefinedRecordType {
  Table_Name: string;
  UD_Record_ID: string;
  UD_Record_GUID: string;
  Edit_Status: string;
  UD_Data: any;
}

export interface UserDefinedTableData {
  Table_Name: string;
  Parent_Object_Code: UserDefinedParentType;
  ID_Name: string;
  UD_Record: UserDefinedRecordType[];
}
